import { render, staticRenderFns } from "./PercentageDiscount.vue?vue&type=template&id=c3cfca60&scoped=true"
import script from "./PercentageDiscount.vue?vue&type=script&lang=js"
export * from "./PercentageDiscount.vue?vue&type=script&lang=js"
import style0 from "./PercentageDiscount.vue?vue&type=style&index=0&id=c3cfca60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3cfca60",
  null
  
)

export default component.exports